import { Sprite } from 'pixi.js';
import { Switch } from '../../../ui';
import { LoadContext } from "../../../utils";

export class BatterySwitch extends Switch
{
    protected offIcon: Sprite;
    protected onIcon: Sprite;

    public static preload()
    {
        LoadContext.current.add('Settings', './assets/accessibility/Settings{size}.json');
    }

    constructor()
    {
        super();

        this.offText.text = 'Unlimited\nChances';
        this.offText.anchor.y = 0;

        const loader = LoadContext.current;
        this.offIcon = new Sprite(loader.getTexture('icon_battery_unlimited', 'Settings'));
        this.offIcon.anchor.set(0.5, 1);
        this.offIcon.position.x = this.offText.position.x - this.offText.width / 2;
        this.offIcon.position.y = this.offText.position.y;
        this.addChild(this.offIcon);

        this.onText.text = 'Battery\nPack';
        this.onText.anchor.y = 0;

        this.onIcon = new Sprite(loader.getTexture('icon_battery_limited', 'Settings'));
        this.onIcon.anchor.set(0.5, 1);
        this.onIcon.position.x = this.onText.position.x + this.onText.width / 2;
        this.onIcon.position.y = this.onText.position.y;
        this.addChild(this.onIcon);
    }

    protected createFocus()
    {
        super.createFocus();

        this.focusBox.position.x = -140;
        this.focusBox.y += 10;
    }

    protected getSize()
    {
        return {width: 430, height: 130};
    }
}